import { useEffect, useState } from "react";
import api from "@/lib/api";
import BlockRenderer from "@/components/BlockRenderer";

function settings(block, device) {
  const base = { ...(block.settings || {}), ...(block.responsive_settings?.[device] || {}) };
  return {
    backgroundColor: base.background || undefined,
    paddingTop: base.paddingTop == null ? undefined : `${base.paddingTop}px`,
    paddingBottom: base.paddingBottom == null ? undefined : `${base.paddingBottom}px`,
    minHeight: base.minHeight == null ? undefined : `${base.minHeight}px`,
    textAlign: base.align || undefined,
    display: base.visible === false ? "none" : undefined,
  };
}

export default function NativePageLayout({ slug, children }) {
  const [page, setPage] = useState(null);
  const [width, setWidth] = useState(() => window.innerWidth);
  useEffect(() => {
    const resize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, []);
  useEffect(() => {
    let active = true;
    api.get(`/pages/${slug}`).then(({ data }) => active && setPage(data)).catch(() => active && setPage(false));
    return () => { active = false; };
  }, [slug]);
  const blocks = page?.metadata?.template === "native_migration" ? page.blocks || [] : [];
  const device = width < 768 ? "mobile" : width < 1280 ? "tablet" : "desktop";
  if (!blocks.length) return children;
  const hasNative = blocks.some((block) => block.type === "native_section" && !block.hidden);
  return (
    <main className="min-h-screen bg-dir-bg" data-testid={`builder-native-${slug}`}>
      {blocks.filter((block) => !block.hidden).map((block) =>
        block.type === "native_section" ? (
          <section key={block.id} style={settings(block, device)} className="min-w-0 overflow-x-clip">
            {block.title && <div className="mx-auto max-w-[1400px] px-4 pt-10 sm:px-6 lg:px-10"><h1 className="font-display text-3xl font-bold text-dir-text sm:text-4xl">{block.title}</h1>{block.text && <p className="mt-3 max-w-3xl text-dir-muted">{block.text}</p>}</div>}
            {children}
          </section>
        ) : (
          <section key={block.id} style={settings(block, device)} className="mx-auto max-w-[1400px] px-4 py-8 sm:px-6 lg:px-10"><BlockRenderer blocks={[block]} /></section>
        ),
      )}
      {!hasNative && children}
    </main>
  );
}
